import { render, staticRenderFns } from "./ReviewStarsDisplay.vue?vue&type=template&id=b799f68e&scoped=true"
import script from "./ReviewStarsDisplay.vue?vue&type=script&lang=js"
export * from "./ReviewStarsDisplay.vue?vue&type=script&lang=js"
import style0 from "./ReviewStarsDisplay.vue?vue&type=style&index=0&id=b799f68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b799f68e",
  null
  
)

export default component.exports